class CustomError extends Error {
  constructor(message = '') {
    super(message);
    this.message = message;
  }

  getMessage() {
    return {
      message: this.message,
      timestamp: new Date(),
    };
  }
}

export default CustomError;
